import * as React from "react";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { RecentDamages } from "Components/Form/RecentDamages";
import { isDefined } from "Utils/functions";
import { FormikProps } from "formik";
import { ProductCategory } from "../../valuablesConstants";
import { ProductIntroFormValues } from "../../valuablesInterface";
import { Details } from "./Details";
import { Products } from "./Products";
import { ValueAndDescription } from "./ValueAndDescription";

interface Props {
  formProps: FormikProps<ProductIntroFormValues>;
}

export const ValuablesProductIntroFormElements = (
  props: Props,
): React.ReactElement => {
  const { formProps } = props;

  const showInputFields =
    isDefined(formProps.values.product) &&
    formProps.values.product !== ProductCategory.OTHER;

  return (
    <>
      <Products formProps={formProps} />

      {showInputFields && (
        <>
          <Details formProps={formProps} />

          <ValueAndDescription formProps={formProps} />

          <RecentDamages
            productName={ProductBackendName.VALUABLES}
            formProps={formProps}
            withSurface
          />
        </>
      )}
    </>
  );
};
